import { MLSListing } from '@aloft/toolkit-shared';

import { MLSDataColumn } from './MLSDataColumn.tsx';
import { MLSDataInfoSection } from './MLSDataInfoSection.tsx';
import { MLSDataValueWithLabel } from './MLSDataValueWithLabel.tsx';

export const MLSPropertyDetails = ({ listingData }: { listingData: MLSListing }) => (
  <MLSDataInfoSection title="Property Details">
    <MLSDataColumn>
      <MLSDataValueWithLabel
        value={listingData.LivingArea?.toLocaleString('en-US')}
        label="Square Feet"
      />
      <MLSDataValueWithLabel value={listingData.Basement?.join(', ')} label="Basement" />
      <MLSDataValueWithLabel value={listingData.StructureType?.join(', ')} label="Structure" />
      <MLSDataValueWithLabel value={listingData.ArchitecturalStyle?.join(', ')} label="Style" />
      <MLSDataValueWithLabel
        value={
          listingData.Stories ??
          listingData.StoriesTotal ??
          listingData.RawMlsStoriesTotal ??
          listingData.Levels ??
          ''
        }
        label="Stories"
      />
      <MLSDataValueWithLabel
        value={listingData.YearBuilt}
        label="Year Built"
        options={{ noCommaInNumber: true }}
      />
      <MLSDataValueWithLabel
        value={listingData.NewConstructionYN ?? false}
        label="New Construction"
      />
      <MLSDataValueWithLabel value={listingData.Roof?.join(', ')} label="Roof" />
      {/* <MlsDataValueWithLabel value={listingData.???} label="Foundation" /> */}
    </MLSDataColumn>
    <MLSDataColumn>
      <MLSDataValueWithLabel value={listingData.BedroomsTotal} label="Bedrooms" />
      <MLSDataValueWithLabel value={listingData.BathroomsFull} label="Full Baths" />
      <MLSDataValueWithLabel value={listingData.BathroomsThreeQuarter} label="3/4 Baths" />
      <MLSDataValueWithLabel value={listingData.BathroomsHalf} label="1/2 Baths" />
      <MLSDataValueWithLabel value={listingData.FireplacesTotal} label="Fireplaces" />
      <MLSDataValueWithLabel
        value={listingData.FireplaceFeatures?.join(', ')}
        label="Fireplace Description"
      />
      <MLSDataValueWithLabel value={listingData.ParkingFeatures?.join(', ')} label="Parking" />
      <MLSDataValueWithLabel value={listingData.ParkingTotal} label="Total Parking Spaces" />
      <MLSDataValueWithLabel value={listingData.GarageYN} label="Has Garage" />
      {listingData.GarageYN && (
        <MLSDataValueWithLabel value={listingData.GarageSpaces} label="Garage Spaces" />
      )}
    </MLSDataColumn>
  </MLSDataInfoSection>
);
